<div class="tab-upper-toiminnot">
  @if (naytaIlmoitusValilehtiObservable | async) {
    <app-button (click)="vaihdaAlvIlmoitukseen.emit()" [dynamicClass]="{ 'tab-valittu-sininen': (valittuTabObservable | async) === 'ilmoitukset' }" actionId="Vaihda välilehti: Ilmoitukset" additionalClass="dark-gray-text">
      @if (yhdistettyStatusObservable | async; as ilmoitusMuutoksia) {
        <div class="tab-label-container">
          <div
            class="tab-pallura"
            [ngClass]="{
              sininenPallura: ilmoitusMuutoksia !== 'yes' && ilmoitusMuutoksia !== 'no' && (valittuTabObservable | async) === 'ilmoitukset',
              kasittelemattaPallura: ilmoitusMuutoksia === 'yes',
              kaikkiOkPallura: ilmoitusMuutoksia === 'no',
              harmaaPallura: ilmoitusMuutoksia !== 'yes' && ilmoitusMuutoksia !== 'no' && (valittuTabObservable | async) !== 'ilmoitukset',
            }"
            [class.mat-elevation-z1]="(valittuTabObservable | async) === 'ilmoitukset'"
          >
            {{ ilmoitusMuutoksia === 'yes' ? '!' : ilmoitusMuutoksia === 'no' ? '✓' : '' }}
          </div>
          <div class="text">Ilmoitukset</div>
        </div>
      }
    </app-button>
  }

  <app-button (click)="vaihdaLahetaNakymaan.emit()" [dynamicClass]="{ 'tab-valittu-sininen': (valittuTabObservable | async) === 'laheta' }" actionId="Vaihda välilehti: lähetys" additionalClass="dark-gray-text">
    <div class="tab-label-container">
      <div
        class="tab-pallura"
        [ngClass]="{
          sininenPallura: (valittuTabObservable | async) === 'laheta' && !onkoSpostejaLahetetty,
          kaikkiOkPallura: onkoSpostejaLahetetty,
          harmaaPallura: !onkoSpostejaLahetetty && (valittuTabObservable | async) !== 'laheta',
        }"
        [class.mat-elevation-z1]="(valittuTabObservable | async) === 'laheta'"
      >
        {{ onkoSpostejaLahetetty ? '✓' : '' }}
      </div>
      <div class="text">Lähetys</div>
    </div>
  </app-button>

  @if (naytaVeroilmoitusValilehtiObservable | async) {
    <app-button (click)="vaihdaVeroilmoitukseen.emit()" [dynamicClass]="{ 'tab-valittu-sininen': (valittuTabObservable | async) === 'vero' }" actionId="Vaihda välilehti: veroilmoitus" additionalClass="dark-gray-text">
      @if (valittuTabObservable | async; as valittuTab) {
        <div class="tab-label-container">
          <div
            class="tab-pallura"
            [ngClass]="{
              kaikkiOkPallura: (veroilmoitusLahetettyObservable | async),
              sininenPallura: !(veroilmoitusLahetettyObservable | async) && valittuTab === 'vero',
              harmaaPallura: valittuTab !== 'vero' && !(veroilmoitusLahetettyObservable | async),
            }"
            [class.mat-elevation-z1]="valittuTab === 'vero'"
          >
            {{ (veroilmoitusLahetettyObservable | async) ? '✓' : '' }}
          </div>
          <div class="text">Veroilmoitus</div>
        </div>
      }
    </app-button>
  }
</div>
